import { clearAction, hideAction, showAction } from './action';

import KfTooltip from './kf-tooltip';
import KfTooltipAnchor from './kf-tooltip-anchor';

export * from './action';
export {
  KfTooltip,
  KfTooltipAnchor,
};


// reducer
export default (state = {}, action) => {
  switch (action.type) {
    // a tooltip is shown
    case String(showAction): {
      const { key, innerHTML, x, y } = action.payload ?? {};
      if (!key) {
        return state;
      }
      return {
        ...state,
        [key]: {
          key, 
          innerHTML,
          x,
          y,
        },
      };
    }

    // a tooltip is hidden
    case String(hideAction): {
      const { key } = action.payload;
      if (!key) {
        return state;
      }
      const ret = { ...state };
      delete ret[key];
      return ret;
    }

    // clear all
    case String(clearAction): {
      return {};
    }
  }
  return state;
};